var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNginx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#009639;}.cls-2{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m7.13,74.75c.45.78,1.1,1.42,1.88,1.86l38.44,22.19h0c1.58.93,3.53.93,5.11,0l38.44-22.19c1.59-.9,2.57-2.59,2.55-4.42V27.81h0c.01-1.83-.96-3.52-2.55-4.42L52.55,1.2h0c-1.58-.93-3.53-.93-5.1,0h0S9.01,23.39,9.01,23.39c-1.59.9-2.57,2.59-2.56,4.42h0v44.38c0,.9.22,1.78.67,2.56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m37.69,66.9c0,2.73-2.21,4.94-4.94,4.94s-4.94-2.21-4.94-4.94h0s0-33.93,0-33.93c.18-2.84,2.63-5,5.47-4.81.05,0,.09,0,.14.01,2.58-.03,5.04,1.07,6.74,3.01l1.49,1.79,20.65,24.71v-24.57h0c0-2.73,2.21-4.94,4.94-4.95,2.73,0,4.94,2.21,4.95,4.94h0s0,0,0,0v33.93c-.19,2.84-2.64,5-5.48,4.81-.05,0-.09,0-.14-.01-2.58.03-5.04-1.07-6.74-3.01l-22.14-26.5v24.57h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNginx);
export default __webpack_public_path__ + "static/media/nginx.aae0aaf288988837305781c70bcaeb44.svg";
export { ForwardRef as ReactComponent };